import { useEffect, useState } from 'react';

const KEY = 'titanv_lang';

const copy = {
  de: {
    search: 'Suchen',
    changelog: 'Changelog',
    light: 'Helles Design',
    dark: 'Dunkles Design',
    logout: 'Abmelden',
    login: 'Anmelden',
    loginDiscord: 'Mit Discord anmelden',
    admin: 'Admin',
    badge: 'TitanV Development Dokumentation',
    hero1: 'Weniger raten.',
    hero2: 'Mehr bauen.',
    lead: 'Die Dokumentation für Scripts, Webseiten und Aufträge. Anleitungen, Referenzen und Beispiele, durchsuchbar und versioniert.',
    browse: 'Dokumentation durchsuchen',
    allProjects: 'Alle Projekte',
    statProjects: 'Projekte',
    statGuides: 'Anleitungen',
    statCategories: 'Kategorien',
    featuresEyebrow: 'Inhalt',
    featuresTitle: 'Gebaut für Leute, die keine Zeit verlieren wollen',
    featSearch: 'Suche',
    featSearchText: 'Funktionen, Beispiele und Referenzen an einem Ort.',
    featCode: 'Code',
    featCodeText: 'Lua, JavaScript, JSON und SQL mit Hervorhebung.',
    featCurrent: 'Aktuell',
    featCurrentText: 'Changelog bei jedem Update.',
    projectsEyebrow: 'Projekte',
    projectsTitle: 'Wähle eine Dokumentation',
    projectsLead: 'Jedes Projekt hat eine eigene Anleitung, egal ob Script, Website oder Auftrag.',
    emptyTitle: 'Noch keine Projekte online',
    emptyText: 'Melde dich als Admin an, um Projekte anzulegen.',
    openDocs: 'Dokumentation öffnen',
    navOverview: 'Übersicht',
    navProjects: 'Projekte',
    navDocs: 'Dokumentation',
    navConfigs: 'Config-Generator',
    navChangelog: 'Changelog',
    navMedia: 'Medien',
    navUsers: 'Benutzer',
    adminRequired: 'Admin-Zugriff erforderlich',
    loadFailed: 'Fehler beim Laden der Daten',
    confirmDelete: 'Löschen bestätigen',
    confirmDeleteText: 'Möchtest du „{{name}}“ wirklich löschen? Das lässt sich nicht rückgängig machen.',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    save: 'Speichern',
    close: 'Schließen',
    project: 'Projekt',
    pickProject: 'Projekt wählen',
    pickCategory: 'Kategorie wählen',
    published: 'Veröffentlicht',
    draft: 'Entwurf',
    orClick: 'oder klicken zum Auswählen',
    translation: 'Übersetzung',
    translationParen: ' (Übersetzung)',
    noDocs: 'Noch keine Dokumentationen erstellt',
    changeFailed: 'Fehler beim Ändern',
    usersTitle: 'Benutzer',
    noUsers: 'Keine Benutzer',
    takeFields: '{{n}} Felder übernehmen',
    pickProjectDots: 'Projekt wählen...',
    addField: 'Feld hinzufügen',
    fieldN: 'Feld {{n}}',
    placeholderHint: 'Verwende {{feldname}} als Platzhalter für die Werte',
    noConfigs: 'Noch keine Config-Templates erstellt',
    noConfigsHint: 'Erstelle ein Template für deine Scripts',
    newTemplate: 'Neues Template',
    editTemplate: 'Template bearbeiten',
    newConfigTemplate: 'Neues Config-Template',
    whichFields: 'Welche Felder sollen editierbar sein?',
    fieldsHelp: 'Aktivierte Felder können vom User angepasst werden. Deaktivierte bleiben fest im Template.',
    german: 'Deutsch',
    saveFailed: 'Fehler beim Speichern',
    createEn: 'Englische Version erstellen',
    statDocs: 'Dokumentationen',
    statMedia: 'Medien',
    statUsers: 'Benutzer',
    statViews: 'Aufrufe',
    noViews: 'Noch keine Aufrufe',
    noEngagement: 'Noch keine Engagement-Daten',
    noProjectsCard: 'Keine Projekte',
    noDocsCard: 'Keine Dokumentationen',
    noFeedback: 'Noch kein Feedback',
    feedbackTitle: 'Feedback Übersicht',
    noChangelog: 'Keine Changelog-Einträge vorhanden.',
    title: 'Titel',
    description: 'Beschreibung',
    changelogTitlePh: 'z.B. Neue Dokumentation hinzugefügt',
    changelogDescPh: 'Details zur Änderung...',
    type: 'Typ',
    linkedDoc: 'Verknüpfte Dokumentation (optional)',
    none: 'Keine',
    publicVisible: 'Öffentlich sichtbar',
    editProject: 'Projekt bearbeiten',
    newProject: 'Neues Projekt',
    adminsOnly: 'Nur für Admins',
    adminsOnlyHint: 'Projekt ist nur im Admin-Bereich sichtbar',
    noProjectsYet: 'Noch keine Projekte erstellt',
    name: 'Name',
    namePh: 'Mein Script',
    slug: 'Slug (URL)',
    slugPh: 'mein-script',
    descPh: 'Kurze Beschreibung des Scripts...',
    icon: 'Icon (Emoji)',
    color: 'Farbe',
    imageCopied: 'Bild-Link kopiert - im Editor einfügen',
    imageUploaded: 'Bild hochgeladen',
    copyImage: 'Bild-Link kopieren',
    noMedia: 'Noch keine Medien hochgeladen',
    projectUpdated: 'Projekt aktualisiert',
    projectCreated: 'Projekt erstellt',
    translationFailed: 'Fehler beim Erstellen der Übersetzung',
    fileTooBig: '{{name}}: Datei zu groß (max. 25 MB)',
    fileDeleted: 'Datei gelöscht',
    deleteFailed: 'Fehler beim Löschen',
    linkCopied: 'Link kopiert - jetzt im Editor einfügen',
    deleted: 'Gelöscht',
    parseFailed: 'Fehler beim Parsen der Config',
    historyFailed: 'Fehler beim Laden der History',
    versionsHint: 'Versionen werden gespeichert wenn du den Inhalt änderst.',
    category: 'Kategorie',
    content: 'Inhalt (Markdown)',
    tags: 'Tags (kommagetrennt)',
    order: 'Reihenfolge',
    templateName: 'Template Name',
    templateNamePh: 'z.B. config.lua',
    templateDescPh: 'Kurze Beschreibung des Templates',
    fields: 'Felder',
    variablePh: 'Variable (z.B. serverName)',
    labelPh: 'Label (z.B. Server Name)',
    defaultPh: 'Standardwert',
    optionsPh: 'Optionen (kommagetrennt)',
    fieldDescPh: 'Beschreibung (optional)',
    luaTemplate: 'Lua Template',
  },
  en: {
    search: 'Search',
    changelog: 'Changelog',
    light: 'Light theme',
    dark: 'Dark theme',
    logout: 'Log out',
    login: 'Log in',
    loginDiscord: 'Log in with Discord',
    admin: 'Admin',
    badge: 'TitanV Development docs',
    hero1: 'Less guessing.',
    hero2: 'More building.',
    lead: 'Documentation for scripts, websites and custom orders. Guides, references and examples, searchable and versioned.',
    browse: 'Search the docs',
    allProjects: 'All projects',
    statProjects: 'Projects',
    statGuides: 'Guides',
    statCategories: 'Categories',
    featuresEyebrow: 'Contents',
    featuresTitle: 'Built for people who do not want to waste time',
    featSearch: 'Search',
    featSearchText: 'Functions, examples and references in one place.',
    featCode: 'Code',
    featCodeText: 'Lua, JavaScript, JSON and SQL with highlighting.',
    featCurrent: 'Current',
    featCurrentText: 'A changelog with every update.',
    projectsEyebrow: 'Projects',
    projectsTitle: 'Choose a documentation',
    projectsLead: 'Each project has its own guide, whether it is a script, a website or a custom order.',
    emptyTitle: 'No projects online yet',
    emptyText: 'Sign in as an admin to create projects.',
    openDocs: 'Open documentation',
    navOverview: 'Overview',
    navProjects: 'Projects',
    navDocs: 'Documentation',
    navConfigs: 'Config generator',
    navChangelog: 'Changelog',
    navMedia: 'Media',
    navUsers: 'Users',
    adminRequired: 'Admin access required',
    loadFailed: 'Could not load the data',
    confirmDelete: 'Confirm delete',
    confirmDeleteText: 'Delete “{{name}}”? This cannot be undone.',
    cancel: 'Cancel',
    delete: 'Delete',
    save: 'Save',
    close: 'Close',
    project: 'Project',
    pickProject: 'Choose a project',
    pickCategory: 'Choose a category',
    published: 'Published',
    draft: 'Draft',
    orClick: 'or click to choose',
    translation: 'Translation',
    translationParen: ' (translation)',
    noDocs: 'No guides yet',
    changeFailed: 'Could not change',
    usersTitle: 'Users',
    noUsers: 'No users',
    takeFields: 'Take {{n}} fields',
    pickProjectDots: 'Choose a project...',
    addField: 'Add field',
    fieldN: 'Field {{n}}',
    placeholderHint: 'Use {{feldname}} as the placeholder for values',
    noConfigs: 'No config templates yet',
    noConfigsHint: 'Create a template for your scripts',
    newTemplate: 'New template',
    editTemplate: 'Edit template',
    newConfigTemplate: 'New config template',
    whichFields: 'Which fields should be editable?',
    fieldsHelp: 'Enabled fields can be changed by the user. Disabled fields stay fixed in the template.',
    german: 'German',
    saveFailed: 'Could not save',
    createEn: 'Create English version',
    statDocs: 'Guides',
    statMedia: 'Media',
    statUsers: 'Users',
    statViews: 'Views',
    noViews: 'No views yet',
    noEngagement: 'No engagement data yet',
    noProjectsCard: 'No projects',
    noDocsCard: 'No guides',
    noFeedback: 'No feedback yet',
    feedbackTitle: 'Feedback overview',
    noChangelog: 'No changelog entries yet.',
    title: 'Title',
    description: 'Description',
    changelogTitlePh: 'e.g. New documentation added',
    changelogDescPh: 'Details of the change...',
    type: 'Type',
    linkedDoc: 'Linked guide (optional)',
    none: 'None',
    publicVisible: 'Visible to the public',
    editProject: 'Edit project',
    newProject: 'New project',
    adminsOnly: 'Admins only',
    adminsOnlyHint: 'The project is only visible in the admin area',
    noProjectsYet: 'No projects yet',
    name: 'Name',
    namePh: 'My script',
    slug: 'Slug (URL)',
    slugPh: 'my-script',
    descPh: 'Short description of the script...',
    icon: 'Icon (emoji)',
    color: 'Color',
    imageCopied: 'Image link copied. Paste it in the editor',
    imageUploaded: 'Image uploaded',
    copyImage: 'Copy image link',
    noMedia: 'No media uploaded yet',
    projectUpdated: 'Project updated',
    projectCreated: 'Project created',
    translationFailed: 'Could not create the translation',
    fileTooBig: '{{name}}: file is too large (max 25 MB)',
    fileDeleted: 'File deleted',
    deleteFailed: 'Could not delete',
    linkCopied: 'Link copied. Paste it in the editor',
    deleted: 'Deleted',
    parseFailed: 'Could not parse the config',
    historyFailed: 'Could not load the history',
    versionsHint: 'Versions are saved when you change the content.',
    category: 'Category',
    content: 'Content (Markdown)',
    tags: 'Tags (comma separated)',
    order: 'Order',
    templateName: 'Template name',
    templateNamePh: 'e.g. config.lua',
    templateDescPh: 'Short description of the template',
    fields: 'Fields',
    variablePh: 'Variable (e.g. serverName)',
    labelPh: 'Label (e.g. server name)',
    defaultPh: 'Default value',
    optionsPh: 'Options (comma separated)',
    fieldDescPh: 'Description (optional)',
    luaTemplate: 'Lua template',
  },
};

function readLang() {
  try {
    return (localStorage.getItem(KEY) || '').startsWith('en') ? 'en' : 'de';
  } catch {
    return 'de';
  }
}

export function useDocsI18n() {
  const [lang, setLang] = useState(readLang);
  useEffect(() => {
    const sync = () => setLang(readLang());
    window.addEventListener('storage', sync);
    window.addEventListener('titanv-lang', sync);
    return () => {
      window.removeEventListener('storage', sync);
      window.removeEventListener('titanv-lang', sync);
    };
  }, []);
  const toggle = () => {
    const next = lang === 'de' ? 'en' : 'de';
    try { localStorage.setItem(KEY, next); } catch { /* ignore */ }
    window.dispatchEvent(new Event('titanv-lang'));
    setLang(next);
  };
  const t = (key, vars) => {
    let text = copy[lang][key] || key;
    if (vars) {
      Object.entries(vars).forEach(([name, value]) => {
        text = text.split(`{{${name}}}`).join(String(value));
      });
    }
    return text;
  };
  return { lang, toggle, t };
}
